import { forwardRef } from "react";
import MoreVertRounded from "@mui/icons-material/MoreVertRounded";
import { IconButton } from "../IconButton";
import type { KebabButtonProps } from "./types";

export const KebabButton = forwardRef<HTMLButtonElement, KebabButtonProps>(
  (props, ref) => (
    <IconButton ref={ref} {...props}>
      <MoreVertRounded fontSize="inherit" />
    </IconButton>
  ),
);

KebabButton.displayName = "KebabButton";
